import React, { useState } from 'react'
import { Box, Chip } from '@mui/material'
import { styled } from '@mui/material/styles'
import Popover from '../PopoverCustom'
import _ from 'lodash'

const Text = styled('div')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '14px',
  textAlign: 'center',
  paddingBottom: '4px',
  color: theme.palette.primary.main,
  letterSpacing: '0.02em',
}))

const ChipCustom = styled(Chip)(({ theme }) => ({
  width: '100%',
  fontFamily: theme.typography.fontFamily,
  fontSize: '13px',
  fontWeight: 600,
  backgroundColor: theme.palette.background.chip || 'rgba(255, 255, 255, 0.9)',
  py: 0,
  height: '26px',
  color: theme.palette.primary.main,
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
  },
}))

const CardContainer = styled(Box)(({ theme }) => ({
  paddingTop: '8px',
}))

const propsChip = (id, isTrue, onMouseEnter, onMouseLeave, label) => ({
  'aria-owns': isTrue ? id : undefined,
  'aria-haspopup': 'true',
  size: 'small',
  onMouseEnter,
  onMouseLeave,
  label,
})

const propsPop = (id, open, anchorEl, onClose, text) => ({
  id,
  open,
  anchorEl,
  onClose,
  text,
})

const boxInside = ({ id, open, state, handle, label, value, description }) => (
  <Box gridColumn="span 1" sx={{ textAlign: 'center' }} key={id}>
    <Text>{label}</Text>
    <ChipCustom {...propsChip(id, open, handle.open, handle.close, value)} />
    <Popover {...propsPop(id, open, state, handle.close, description)} />
  </Box>
)

const ContainerPopover = ({ attributes = [], carbon = null }) => {
  const [dapHover, setDapHover] = useState(null)
  const [htHover, setHtHover] = useState(null)
  const [carbonoHover, SetCarbonoHover] = useState(null)

  const HANDLE = {
    DAP: {
      stateBoolean: Boolean(dapHover),
      description: 'DAP',
      stateHover: dapHover,
      open: event => setDapHover(event.currentTarget),
      close: () => setDapHover(null),
    },
    HT: {
      stateBoolean: Boolean(htHover),
      description: 'HT',
      stateHover: htHover,
      open: event => setHtHover(event.currentTarget),
      close: () => setHtHover(null),
    },
    CARBONO: {
      stateBoolean: Boolean(carbonoHover),
      stateHover: carbonoHover,
      description: 'Carbono Almacenado',
      open: event => SetCarbonoHover(event.currentTarget),
      close: () => SetCarbonoHover(null),
    },
  }

  let data = []
  const keysAttributes = ['dap', 'ht', 'carbono']

  keysAttributes.forEach(key => {
    let upperLabel = null
    let value = null
    const _handle = HANDLE[`${_.toUpper(key)}`]
    if (key !== 'carbono') {
      attributes.forEach(obj => {
        if (key !== obj.metaFeature.key) return
        upperLabel = obj.metaFeature.nombre
        value = `${parseFloat(obj.value).toFixed(2)} ${obj.metaFeature.u_medida}`
      })
    } else {
      upperLabel = 'Carbono Alm.'
      value =
        carbon.value && Math.sign(carbon.value) === 1
          ? `${parseFloat(carbon.value * 0.5 || 0).toFixed(2)} ${carbon.unit}`
          : 'Sin estimar'
    }

    data.push({
      id: key,
      open: _handle.stateBoolean,
      state: _handle.stateHover,
      handle: _handle,
      label: upperLabel,
      value: value,
      description: HANDLE[`${_.toUpper(key)}`].description,
    })
  })

  return (
    <Box sx={{ py: 0, paddingBottom: '8px' }}>
      <CardContainer>
        <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={'8px'}>
          {data.map(obj => boxInside(obj))}
        </Box>
      </CardContainer>
    </Box>
  )
}
export default ContainerPopover
